export default __webpack_public_path__ + "static/media/services.5e4865f9.svg";